import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import BsModal from "../BsModal";
import Scrollpane from "../Scrollpane";
import Searchbox from "../Searchbox";
import ReactToPrint from "react-to-print";
import FamTable from "./FamTable";

export default class FamDocModal extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      tableRef: React.createRef(),
    };
  }
  onSearch = (search) => {
    this.setState({ search });
  };

  onClick = () => {
    if (this.props.onClick) {
      this.props.onClick();
    }
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const { search } = this.state;
    const { mode, view } = this.props;

    let listSource = this.props.list;
    let list = [];

    let modalTitle = "";
    let printTitle = "";

    if (view === "document") {
      modalTitle = mode === "fam" ? "Ознакомлен" : "Не ознакомлен";
      printTitle =
        mode === "fam"
          ? "Лист ознакомления сотрудника"
          : "Перечень докуементов, ожидающих ознакомления";
    }
    if (view === "staff") {
      modalTitle = mode === "fam" ? "Ознакомлены" : "Не ознакомлены";
      printTitle =
        mode === "fam"
          ? "Лист ознакомления с документом"
          : "Сотрудники, не ознакомленные с документом";
    }

    if (search) {
      let searchReg = new RegExp(this.context.api.regexEscape(search), "i");
      list = listSource.filter((item) => item.label.search(searchReg) > -1);
    } else {
      list = listSource;
    }
    return (
      <>
        <BsModal center {...this.props}>
          <div className="mb-5 pb-2">
            <div className="d-flex align-items-center justify-content-between">
              <h5>{modalTitle}:</h5>
              <div>
                <button
                  onClick={this.props.onSwitchMode}
                  className="btn btn-light btn-icon"
                >
                  <i className="fa fa-retweet"></i>
                </button>
              </div>
            </div>
            <div className="d-flex mt-3">
              <div className="flex-grow-1">
                <Searchbox onSearch={this.onSearch} />
              </div>
              <div>
                <ReactToPrint
                  trigger={() => (
                    <button
                      className="btn btn-icon btn-light ml-1"
                      title="Печать перечня"
                    >
                      <i className="fa fa-print"></i>
                    </button>
                  )}
                  content={() => this.state.tableRef.current}
                />
              </div>
            </div>
          </div>

          <div style={{ display: "none" }}>
            <div className="to-print" ref={this.state.tableRef}>
              <FamTable title={printTitle} list={list} qr={mode === "fam"} />
            </div>
          </div>
          <Scrollpane>
            {list.map((item, idx) => {
              return (
                <div key={idx} className="mb-4">
                  {view === "document" && (
                    <ItemDoc item={item} onClick={this.onClick} />
                  )}
                  {view === "staff" && (
                    <ItemStaff item={item} onClick={this.onClick} />
                  )}
                </div>
              );
            })}
          </Scrollpane>
        </BsModal>
      </>
    );
  }
}

function ItemDoc(props) {
  const { item, onClick } = props;
  let dtDoc = item.validfromdate ? new Date(item.validfromdate) : {};
  let dtFam = item.date ? new Date(item.date) : {};
  return (
    <>
      <Link
        to={`/manual/all/${item.manual}`}
        className="text-dark text-hover-primary"
        onClick={onClick}
      >
        {item.label}
      </Link>
      <div className="small text-muted d-flex justify-content-between mt-1">
        <div title="Дата документа">{dtDoc.toLocaleString()}</div>
        <div title="Версия документа">{item.version}</div>
        {item.date && (
          <div className="text-success" title="Дата ознакомления">
            <i className="fa fa-check mr-2 text-success"></i>
            {dtFam.toLocaleString()}
          </div>
        )}
      </div>
    </>
  );
}

function ItemStaff(props) {
  const { item, onClick } = props;
  let dtDoc = item.validfromdate ? new Date(item.validfromdate) : {};
  let dtFam = item.date ? new Date(item.date) : {};
  return (
    <>
      <div>
        {item.staffname}
        {item.positionname && (
          <span className="text-muted ml-2 small"> / {item.positionname}</span>
        )}
      </div>
      <div class="small text-muted d-flex justify-content-between mt-1">
        {item.date && (
          <div className="text-success" title="Дата ознакомления">
            <i className="fa fa-check mr-2 text-success"></i>
            {dtFam.toLocaleString()}
          </div>
        )}
      </div>
    </>
  );
}
